import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import LegalPage from './pages/LegalPage';
import CateringInquiry from './pages/CateringInquiry';
import { Toaster } from './components/ui/sonner';
import { VacationNotice } from './components/VacationNotice';
import { PRIVACY, TERMS, ACCESSIBILITY } from './legalContent';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catering-inquiry" element={<CateringInquiry />} />
            <Route path="/privacy" element={<LegalPage {...PRIVACY} />} />
            <Route path="/terms" element={<LegalPage {...TERMS} />} />
            <Route path="/accessibility" element={<LegalPage {...ACCESSIBILITY} />} />
          </Routes>
        </BrowserRouter>
        <VacationNotice />
        <Toaster position="bottom-right" richColors />
      </HelmetProvider>
    </div>
  );
}

export default App;
